<template>
  <div>
    <v-row>
      <v-col
        style="padding: 0 0 0 12px !important;"
      >
        <div
          class="body-message"
        >
          {{ $t('fleet/vehicle/vehicle_service_interval.archive_dialog_message') }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <text-field
          v-if="startStateType === 'text'"
          v-model="formData.start_state"
          :field="{
            key: 'email',
            label: startStateLabel,
            field_type: startStateFieldType,
            suffix: startStateSuffix
          }"
          :validation-errors="validationErrors"
          @clear-validation-errors="$emit('clear-validation-errors', 'start_state')"
        />
        <template
          v-else
        >
          <v-menu
            v-model="datePicker"
            transition="slide-y-transition"
            nudge-top="530"
            offset-y
            min-width="auto"
            :close-on-content-click="false"
          >
            <template
              #activator="{}"
            >
              <text-field
                v-model="formData.start_state"
                :field="{
                  key: 'start_state',
                  label: startStateLabel,
                  suffix: startStateSuffix,
                  appendIcon: startStateAppendIcon
                }"
                :validation-errors="validationErrors"
                @append-click="datePicker = true"
                @clear-validation-errors="$emit('clear-validation-errors', 'start_state')"
              />
            </template>
            <datetime-picker
              v-if="datePicker"
              v-model="formData.start_state"
              :date-format="dateFormat"
              :field="{
                key: 'start_state',
                subType: startStateSubType
              }"
              @close="datePicker = false"
              @dblclick:date="onDateDblClick"
            />
          </v-menu>
        </template>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <textarea-field
          v-model="formData.note"
          :config="{
            key: 'note',
            label: $t('fleet/vehicle_service.archive_service_note')
          }"
          :validation-errors="validationErrors"
          @clear-validation-errors="$emit('clear-validation-errors', 'note')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextField from '@/global/components/fields/TextField.vue'
import DatetimePicker from '@/global/components/fields/DatetimePicker.vue'
import TextareaField from '@/global/components/fields/TextareaField.vue'
import { FORMATS } from '@/global/services/date'

export default {
  name: 'ArchiveServiceInterval',

  components: {
    TextareaField,
    DatetimePicker,
    TextField
  },

  props: {
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      formData: {},
      startStateType: 'text',
      startStateFieldType: 'text',
      startStateSuffix: '',
      startStateSubType: '',
      startStateAppendIcon: undefined,
      startStateDateFormat: FORMATS.date,
      startStateLabel: '',
      datePicker: false,
      dateFormat: FORMATS.date
    }
  },

  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        this.$emit('update-data', val)
      }
    },
    type: {
      immediate: true,
      deep: true,
      handler (val) {
        const { name } = val || {}

        if (name) {
          this.configDynamicFields(name)
        }
      }
    }
  },

  created () {
    // clear form data every time when dialog is opened
    this.formData = {}
    this.$emit('remove-all-validation-errors')
  },

  methods: {
    configDynamicFields (name) {
      switch (name) {
        case 'km':
          this.startStateType = 'text'
          this.startStateFieldType = 'number'
          this.startStateSuffix = 'km'
          this.startStateAppendIcon = undefined
          this.startStateLabel = this.$t('fleet/vehicle_service.archive_service_input_label_km')
          this.startStateVisible = true
          break
        case 'hours':
          this.startStateType = 'text'
          this.startStateFieldType = 'number'
          this.startStateSuffix = 'h'
          this.startStateVisible = true
          this.startStateLabel = this.$t('fleet/vehicle_service.archive_service_input_label_h')
          break
        case 'date':
          this.startStateType = 'datetime-picker'
          this.startStateSubType = 'date'
          this.startStateFieldType = 'text'
          this.startStateSuffix = undefined
          this.startStateDateFormat = FORMATS.date
          this.startStateAppendIcon = 'mdi-calendar-month'
          this.startStateLabel = this.$t('fleet/vehicle_service.archive_service_input_label_d')
          this.startStateVisible = true
      }
    },

    onDateDblClick (instance) {
      const { applyDate } = instance || {}
      if (typeof applyDate === 'function') {
        applyDate()
      }
    }
  }
}
</script>

<style scoped>
.body-message {
  font-style: italic;
  font-size: 14px;
  text-align: left;
  color: grey;
}
</style>
